import React from "react";
import excel from "../../images/excel.png";
import EFTPaymentList from "./EFTPaymentList.js";
import PaymentReportPagination, { PaymentReportHeaderRow } from "./PaymentReportPagination";
import usePaymentReport from "./usePaymentReport";
import usePaymentPagination from "./usePaymentPagination";
import { buildPaymentRows, downloadPaymentXlsx } from "./paymentExcel";

export default function EFTPaymentStatus(props) {
    const data = usePaymentReport("eft", props);
    const { offset, limit, page, itemsPerPage, setitems, pageBack, pageForward } = usePaymentPagination(data);

    function handleDownloadClick() {
        const rows = buildPaymentRows(data, {
            idLabel: "EFT ID",
            getIdCell: (patient) => {
                try {
                    return patient.claim_data.trace_id;
                } catch {
                    return "";
                }
            },
        });
        downloadPaymentXlsx(rows, "EFT Payment Status", "EFTPaymentStatus");
    }

    return (
        <div className="col-sm-12 col-md-12 col-lg-12">
            <div className="clear">
                <div className="border-color">
                    <strong>
                        <span className="underline">EFT Payment Status:</span>
                    </strong>
                    <strong>Approved:</strong> Claim has been approved and funds are awaiting transfer to bank
                    <br />
                    <strong>Sent to Bank:</strong> Funds are pending the bank transfer for deposit
                    <br /> <strong>Paid:</strong> Funds are deposited into your account
                </div>
            </div>
            <span className="tooltip" style={{ float: "right" }}>
                <a onClick={handleDownloadClick}>
                    <img src={excel} className="excel" />
                </a>
                <span className="tooltiptext">
                    Click here to download entire patient list. Please note there is a 24 hour delay for newly enrolled patients to be
                    included in this excel list
                </span>
            </span>
            <table style={{ marginTop: "0", marginBottom: "0" }} className="account">
                <tbody>
                    <PaymentReportHeaderRow idLabel="EFT ID" />
                    <EFTPaymentList data={data} page={page} items={itemsPerPage} offset={offset} limit={limit} />
                </tbody>
            </table>
            <PaymentReportPagination
                data={data}
                offset={offset}
                limit={limit}
                setitems={setitems}
                pageBack={pageBack}
                pageForward={pageForward}
            />
        </div>
    );
}


